import { render, staticRenderFns } from "./ShopStorePayHuifu.vue?vue&type=template&id=0560465f&scoped=true&"
import script from "./ShopStorePayHuifu.vue?vue&type=script&lang=js&"
export * from "./ShopStorePayHuifu.vue?vue&type=script&lang=js&"
import style0 from "./ShopStorePayHuifu.vue?vue&type=style&index=0&id=0560465f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0560465f",
  null
  
)

export default component.exports